import React, {useState} from "react";
import {LanguageProvider} from "./provider/language";
import {FirebaseProvider} from "./provider/firebase";
import {AssetProvider} from "./provider/asset";
import {SliderItemsProvider} from "./provider/slider-item";
import {FAQProvider} from "./provider/faqs";
import {createGlobalStyle} from "styled-components";
import {QueryParamProvider} from "use-query-params";
import {globalHistory} from "@gatsbyjs/reach-router";
import DynamicThemeProvider from "./provider/dynamic-theme";
import {Helmet} from "react-helmet";

interface TRootContext {
  error: any;
  setError: Function;
  location: Location;
  /* Whether TS particles currently is active on a page. Used to invert logos, e.g. */
  toggleLogos: any;
  logosInverted: boolean;
}

export const RootContext = React.createContext<TRootContext>(null);

const GlobalStyle = createGlobalStyle`
  body {
    background-image: ${(props) => props.theme.backgroundColor};
    color: ${(props) => props.theme.fontColor};
  }
`;

const AppProviders = ({element, props}) => {
  const [error, setError] = useState(null);
  const [invertedLogos, setInvertedLogos] = useState(false);

  const pageContextValue = {
    setError,
    error,
    location: props?.location,
    toggleLogos: () => setInvertedLogos(!invertedLogos),
    logosInverted: invertedLogos
  };

  const wrappedElement = (
    <RootContext.Provider value={pageContextValue}>
      <LanguageProvider>
        <FirebaseProvider>
          <AssetProvider>
            <DynamicThemeProvider>
              <SliderItemsProvider>
                <FAQProvider>
                  <GlobalStyle error={error} />

                  {element}
                </FAQProvider>
              </SliderItemsProvider>
            </DynamicThemeProvider>
          </AssetProvider>
        </FirebaseProvider>
      </LanguageProvider>
    </RootContext.Provider>
  );

  return (
    <QueryParamProvider
      location={props?.location ?? globalHistory.location}
      reachHistory={globalHistory}
    >
      {wrappedElement}
    </QueryParamProvider>
  );
};

const withRoot = ({element, props}) => {
  return <AppProviders element={element} props={props} />;
};

export default withRoot;
